import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { checkPixel } from 'utils';

export function Img({ src, alt, onClick, ...props }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (src) {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        setLoading(false);
      };
    }

    return () => setLoading(true);
  }, [src]);

  return <ImgWrap src={src} alt={alt} $loading={loading} onClick={onClick} {...props} />;
}

export const ImgWrap = styled.img`
  width: 100%;
  height: ${({ $height }) => ($height && `${checkPixel($height)}`) || '100%'};
  object-fit: ${({ $objectFit }) => ($objectFit && `${$objectFit}`) || 'contain'};
  filter: ${({ $loading }) => ($loading && `blur(10px)`) || `blur(0)`};
  transition: all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
  ${({ $width }) => ($width && `max-width:${checkPixel($width)}`) || '100%'};
  ${({ $objectPosition }) => $objectPosition && `object-position: ${$objectPosition}`};
  ${({ $pointer }) => $pointer && `cursor:pointer`};
  ${({ $objectFit }) => $objectFit && `object-fit: ${$objectFit}`};

  @media ${({ theme }) => theme.device.tablet} {
    ${({ $tWidth }) => $tWidth && `max-width:${checkPixel($tWidth)}`};
    ${({ $tHeight }) => $tHeight && `height: ${checkPixel($tHeight)}`};
    ${({ $tObjectFit }) => $tObjectFit && `object-fit: ${$tObjectFit}`};
  }

  @media ${({ theme }) => theme.device.mobile} {
    ${({ $mWidth }) => $mWidth && `max-width: ${checkPixel($mWidth)}`};
    ${({ $mHeight }) => $mHeight && `height: ${checkPixel($mHeight)}`};
    ${({ $mObjectFit }) => $mObjectFit && `object-fit: ${$mObjectFit}`};
  }
`;
